// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CountryIsoCode from "../entity/CountryIsoCode.bs.js";
import * as CountryApiModel from "../api-model/CountryApiModel.bs.js";
import * as CountryConfigMapper from "./CountryConfigMapper.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function execute(json) {
  var api_res = DeccoUtils$Catalyst.resolveResult(CountryApiModel.t_decode(json), "CountryEntity.re");
  return CountryConfigMapper.execute(CountryIsoCode.fromString(api_res.currency_config.iso_code, api_res.timezone_config.config, api_res.currency_config.symbol, api_res.mobile_validation_regex_str));
}

export {
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
